var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOffices = function SvgOffices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    fillRule: "nonzero",
    stroke: "currentcolor",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.214 6.988c-.823-2.66-2.962-4.817-5.583-5.629-2.79-.864-5.698-.395-7.98 1.287A8.94 8.94 0 0 0 2.028 5.72a8.866 8.866 0 0 0-.984 4.054c0 1.92.607 3.744 1.756 5.276l7.044 8.985 7.035-8.974.009-.011c1.72-2.292 2.203-5.23 1.326-8.062Zm-2.405 7.244-5.965 7.61-5.965-7.61a7.383 7.383 0 0 1-1.481-4.458 7.534 7.534 0 0 1 3.057-6.038c1.931-1.424 4.401-1.819 6.776-1.083 2.2.68 3.997 2.495 4.69 4.735.746 2.41.34 4.904-1.112 6.844Z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 6.435c-1.82 0-3.3 1.48-3.3 3.3 0 1.82 1.48 3.3 3.3 3.3 1.82 0 3.3-1.48 3.3-3.3 0-1.82-1.48-3.3-3.3-3.3Zm0 5.5c-1.213 0-2.2-.987-2.2-2.2s.987-2.2 2.2-2.2 2.2.987 2.2 2.2-.987 2.2-2.2 2.2Z"
  }))));
};

export default SvgOffices;